import { GlobeAltIcon } from "@heroicons/react/24/outline";
import { useState, useEffect } from "react";
import cargandoCard from "../../../components/cargando-card";
import { useHistory, } from "react-router-dom";
import spinner from "../../../assets/iconos/spinner4.svg";
import { useTranslation } from "react-i18next";
import { STRING_COLOR_PRIMARIO, STRING_LANGUAGE, STRING_NAME_COMPANY, STRING_URL_LOGO } from "../../../utils/const/string-const";
import { ESTILO_BOTON_LISTAR_ATRAS, ESTILO_BOTON_MODAL_ACEPTAR } from "../../../utils/const/estilos-const";
import { actualizarConfiguracionEmpresa, createConfiguracionEmpresa, obtenerConfiguracionEmpresa } from "../../../api/api-configuracion-empresa";
import ColorPickerInput from "../../../components/color-picker-input";
import PopUpLoadingComponent from "../../../components/pop-up-loading";
import moment from "moment";
import { guardarImagenGenerico } from "../../../api/api-imagen";
import { COLOR_AZUL_MAIN } from "../../../utils/const/colors-const";

export default function ConfiguracionEmpresa() {

    const { t, i18n } = useTranslation();
    // const location = useLocation();
    const history = useHistory();
    const [cargandoPage, setCargandoPage] = useState(true);
    const [isOpen, setIsOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        id: 0,
        nombreEmpresa: "",
    });
    const [primaryColor, setPrimaryColor] = useState("#1F69AD");
    const [primaryColorButton, setPrimaryColorButton] = useState(COLOR_AZUL_MAIN);
    const [secondaryColor, setSecondaryColor] = useState("#84B044");
    const [thirdColor, setThirdColor] = useState("#84B044");
    const [menuColor, setMenuColor] = useState("#FFFFFF");
    const [urlLogo, setUrlLogo] = useState(null);
    const [popUpLoadingVisible, setPopUpLoadingVisible] = useState(false);
    const [images, setImages] = useState([]);

    const [isHovered, setIsHovered] = useState(false);
    const hoverColor = COLOR_AZUL_MAIN;


    useEffect(() => {
        const mainColor = localStorage.getItem(STRING_COLOR_PRIMARIO);
        if (mainColor !== null) {
            setPrimaryColorButton(mainColor);
        }
        iniciar();
    }, []);

    const iniciar = async () => {
        try {
            const config = await obtenerConfiguracionEmpresa();
            // console.log('config');
            // console.log(config);
            if (config !== null) {
                setFormData({
                    ...formData,
                    id: config.body.id,
                    nombreEmpresa: config.body.nombreEmpresa,
                });
                if (config.body.colorPrimario !== null) {
                    setPrimaryColor(config.body.colorPrimario);
                }
                if (config.body.colorSecundario !== null) {
                    setSecondaryColor(config.body.colorSecundario);
                }
                if (config.body.colorTerciario !== null) {
                    setThirdColor(config.body.colorTerciario);
                }
                if (config.body.colorMenu !== null) {
                    setMenuColor(config.body.colorMenu);
                }
                if (config.body.urlLogo !== null) {
                    setImages([config.body.urlLogo]);
                    setUrlLogo(config.body.urlLogo);
                }
            }
            setCargandoPage(false);
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
            setCargandoPage(false);
        }
    };

    const languages = [
        { code: "en", label: "English" },
        { code: "es", label: "Español" },
        { code: "pt", label: "Português" }
    ];

    const charLimits = {
        nombreEmpresa: 64,
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (value.length <= charLimits[name]) {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    };

    const changeLanguage = (code) => {
        localStorage.setItem(STRING_LANGUAGE, code);
        i18n.changeLanguage(code);
        setIsOpen(false);
    };

    const handleAtrasClick = () => {
        history.goBack();
    };

    const navigateToLogin = () => {
        localStorage.removeItem(STRING_LANGUAGE);
        localStorage.removeItem(STRING_COLOR_PRIMARIO);
        localStorage.removeItem(STRING_URL_LOGO);
        localStorage.removeItem(STRING_NAME_COMPANY);
        history.push("/login");
    };

    const handleSave = async () => {
        try {
            // console.log('handleSave');
            // console.log(formData);
            const idioma = localStorage.getItem(STRING_LANGUAGE);
            // console.log('idioma');
            // console.log(idioma);
            let objEnviar = {};
            objEnviar.id = formData.id;
            objEnviar.nombreEmpresa = formData.nombreEmpresa;
            objEnviar.idioma = idioma;
            objEnviar.primaryColor = primaryColor;
            objEnviar.secondaryColor = secondaryColor;
            objEnviar.thirdColor = thirdColor;
            objEnviar.menuColor = menuColor;
            objEnviar.urlLogo = urlLogo;
            // console.log('objEnviar');
            // console.log(objEnviar);
            // return;
            if (objEnviar.id === 0) {
                const resp = await createConfiguracionEmpresa(objEnviar);
                // console.log('resp');
                // console.log(resp);
                if (resp.error === false) {
                    alert(t("alert_successfully_proccess") + "\n" + t("alert_need_to_login_again"));
                    navigateToLogin();
                    return;
                }
                if (resp.error === true) {
                    alert(t("alert_could_not_process") + "\n" + resp.message);
                }
            }
            if (objEnviar.id !== 0) {
                const resp = await actualizarConfiguracionEmpresa(objEnviar);
                // console.log('resp');
                // console.log(resp);
                if (resp.error === false) {
                    alert(t("alert_successfully_proccess") + "\n" + t("alert_need_to_login_again"));
                    navigateToLogin();
                    return;
                }
                if (resp.error === true) {
                    alert(t("alert_could_not_process") + "\n" + resp.message);
                }
            }
        } catch (err) {
            console.log('handleSave err');
            console.log(err);
        }
    };

    const handleDrop = (event) => {
        if (images.length >= 1) {
            alert(t("alert_you_can_only_upload_one_image"));
            return;
        }
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        if (file) {
            convertToBase64(file);
        }
    };

    const handleFileSelect = (event) => {
        if (images.length >= 1) {
            alert(t("alert_you_can_only_upload_one_image"));
            return;
        }
        // console.log("File input event:", event);
        if (!event.target.files) {
            console.error("No files detected in event.target.files.");
            return;
        }

        const file = event.target.files[0];
        // console.log("Selected file:", file);

        if (file) {
            convertToBase64(file);
        } else {
            console.error("No file selected.");
        }
    };

    // Convert image file to Base64
    const convertToBase64 = (file) => {
        const MAX_SIZE = 1024 * 1024; // 1MB in bytes

        if (file.size > MAX_SIZE) {
            alert("The image is bigger than the allowed size (1MB). Please select a smaller file.");
            return;
        }

        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            const base64String = reader.result.split(",")[1]; // Extract only the Base64 data
            uploadImage(base64String);
        };
        reader.onerror = (error) => {
            console.error("Error converting to Base64:", error);
        };
    };

    const uploadImage = async (file) => {
        try {
            // console.log('uploadImage');
            // console.log(file);
            setPopUpLoadingVisible(true);
            let objEnviar = {};
            objEnviar.base64 = file;
            objEnviar.nombre = moment().unix() + '.png';
            objEnviar.tipoArchivo = ".png";
            const response = await guardarImagenGenerico(objEnviar);
            console.log('response');
            console.log(response);
            if (response.error === false) {
                setImages([...images, response.body.url_fotografia]);
                setUrlLogo(response.body.url_fotografia);
            } else {
                alert("Upload failed");
            }
            setPopUpLoadingVisible(false);
        } catch (error) {
            console.error("Error uploading image:", error);
            setPopUpLoadingVisible(false);
        }
    };

    const deleteImage = async (imageUrl) => {
        try {
            setImages(images.filter((img) => img !== imageUrl));
            setUrlLogo(null);
        } catch (error) {
            console.error("Error deleting image:", error);
        }
    };

    const render = () => {

        try {
            if (cargandoPage === true) {
                return cargandoCard();
            }
            if (cargandoPage === false && formData === null) {
                return (
                    <div>
                        <label> Sin data</label>
                    </div>
                );
            }
            return (
                <div className="p-4 ">
                    <div className="relative inline-block text-left">
                        <button
                            onClick={() => setIsOpen(!isOpen)}
                            className="flex items-center gap-2 px-4 py-2 bg-[#000D39] text-white font-semibold rounded-lg shadow-md hover:bg-[#122857] focus:outline-none"
                        >
                            <GlobeAltIcon className="w-5 h-5" />
                            {t("Select Language")}
                            <span className="ml-2 text-sm text-gray-300">({i18n.language.toUpperCase()})</span>
                        </button>

                        {isOpen && (
                            <div className="absolute right-0 mt-2 w-40 bg-white rounded-lg shadow-lg z-10">
                                {languages.map((lang) => (
                                    <button
                                        key={lang.code}
                                        onClick={() => changeLanguage(lang.code)}
                                        className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-[#000D39] focus:outline-none"
                                    >
                                        {lang.label}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                    <div className="grid grid-cols-12 gap-4 pt-4">
                        <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3 ">
                            <label className="block text-gray-600 font-semibold mb-1">{t("label_name_company")}</label>
                            <input
                                name="nombreEmpresa"
                                value={formData.nombreEmpresa}
                                onChange={handleInputChange}
                                placeholder={t("placeholde_enter_nombre_empresa")}
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                            />
                            <p className="text-sm text-gray-500 flex justify-end">{formData.nombreEmpresa.length}/{charLimits.nombreEmpresa}</p>
                        </div>
                    </div>
                    <div className="grid grid-cols-12 gap-4 pt-4">
                        <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3 ">
                            <label className="block text-gray-600 font-semibold mb-1">{t("label_primary_color")}</label>
                            <ColorPickerInput
                                color={primaryColor}
                                setColor={setPrimaryColor}
                            />
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3 ">
                            <label className="block text-gray-600 font-semibold mb-1">{t("label_secondary_color")}</label>
                            <ColorPickerInput
                                color={secondaryColor}
                                setColor={setSecondaryColor}
                            />
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3 ">
                            <label className="block text-gray-600 font-semibold mb-1">{t("label_third_color")}</label>
                            <ColorPickerInput
                                color={thirdColor}
                                setColor={setThirdColor}
                            />
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3 ">
                            <label className="block text-gray-600 font-semibold mb-1">{t("label_menu_color")}</label>
                            <ColorPickerInput
                                color={menuColor}
                                setColor={setMenuColor}
                            />
                        </div>
                    </div>
                    <br />
                    <div className="grid grid-cols-12 gap-4 pt-4">
                        <div className="col-span-12 ">
                            <div className="max-w-lg mx-auto p-6">
                                {/* Drag and Drop Area */}
                                <div
                                    className="border-2 border-dashed border-gray-400 p-10 text-center cursor-pointer"
                                    onDrop={handleDrop}
                                    onDragOver={(e) => e.preventDefault()}
                                >
                                    <p className="text-gray-600">Drag & Drop an image or</p>
                                    <input type="file" className="hidden" onChange={handleFileSelect} id="fileInput" />
                                    <label htmlFor="fileInput" className="bg-blue-500 text-white px-4 py-2 rounded cursor-pointer mt-2 inline-block">
                                        Select File
                                    </label>
                                </div>

                                {/* Uploaded Images List */}
                                <div className="mt-4">
                                    {images.map((image, index) => (
                                        <div key={index} className="flex items-center justify-between p-2 border rounded mt-2">
                                            <img src={image} alt="Uploaded" className="w-16 h-16 object-cover rounded" />
                                            <button className="bg-red-500 text-white px-2 py-1 rounded" onClick={() => deleteImage(image)}>
                                                Delete
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                    <div className=" flex items-center justify-between">
                        <button
                            type="button"
                            className={ESTILO_BOTON_LISTAR_ATRAS}
                            onClick={(handleAtrasClick)}
                        >
                            {t("label_back")}
                        </button>
                        {loading === false &&
                            <button
                                type="button"
                                className={`${ESTILO_BOTON_MODAL_ACEPTAR}`}
                                style={{
                                    backgroundColor: isHovered ? hoverColor : primaryColorButton,
                                }}
                                onMouseEnter={() => setIsHovered(true)}
                                onMouseLeave={() => setIsHovered(false)}
                                onClick={handleSave}
                            >
                                Guardar
                            </button>
                        }
                        {loading === true &&
                            <button
                                className="bg-[#84B044] text-white font-semibold py-2 px-4 rounded-lg hover:bg-[#6f9239] transition duration-300 flex justify-center items-center"
                            >
                                <img className="spinner" alt="spinner" src={spinner} />
                            </button>

                        }
                    </div>
                    <PopUpLoadingComponent
                        isOpen={popUpLoadingVisible}
                    />
                </div>
            );
        } catch (err) {
            console.log('Configuracion Empresa render err');
            console.log(err);
            return (
                <div>
                    <label>{JSON.stringify(err)}</label>
                </div>
            );
        }
    }

    return render();
};

